import { render, staticRenderFns } from "./simDistributRecord.vue?vue&type=template&id=7ddb19f2&scoped=true&"
import script from "./simDistributRecord.vue?vue&type=script&lang=js&"
export * from "./simDistributRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb19f2",
  null
  
)

export default component.exports